package web.fstech.onthecoffee.privacy

import web.fstech.onthecoffee.mvi.MviViewModel
import web.fstech.onthecoffee.mvi.UiEffect
import web.fstech.onthecoffee.mvi.UiIntent
import web.fstech.onthecoffee.mvi.UiState

enum class AppLanguage {
    ENGLISH, ARABIC
}

data class PrivacyState(
    val language: AppLanguage = AppLanguage.ENGLISH
) : UiState

sealed interface PrivacyIntent : UiIntent {
    data class SelectLanguage(val language: AppLanguage) : PrivacyIntent
}

sealed interface PrivacyEffect : UiEffect

class PrivacyViewModel : MviViewModel<PrivacyState, PrivacyIntent, PrivacyEffect>(PrivacyState()) {
    override fun handleIntent(intent: PrivacyIntent) {
        when (intent) {
            is PrivacyIntent.SelectLanguage -> updateState { copy(language = intent.language) }
        }
    }
}
